// Authentication utility functions that can be tested independently

export interface OtpRequestData {
  email: string;
  recaptcha?: string | null;
  vid?: string | null;
}

export interface OtpVerifyData {
  email: string;
  code: string;
  recaptcha?: string | null;
}

/**
 * Validates email format
 */
export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Validates OTP code format (6 digits)
 */
export function validateOtpCode(code: string): boolean {
  return /^\d{6}$/.test(code);
}

/**
 * Formats OTP request data for API
 */
export function formatOtpRequestData(
  email: string,
  recaptchaToken?: string | null,
  analyticsId?: string | null,
): OtpRequestData {
  return {
    email: email.toLowerCase().trim(),
    recaptcha: recaptchaToken || null,
    vid: analyticsId || null,
  };
}

/**
 * Formats OTP verification data for API
 */
export function formatOtpVerifyData(
  email: string,
  code: string,
  recaptchaToken?: string | null,
): OtpVerifyData {
  return {
    email: email.toLowerCase().trim(),
    code: code.trim(),
    recaptcha: recaptchaToken || null,
  };
}

/**
 * Checks if there's a pending monitor URL in localStorage
 */
export function getPendingMonitorUrl(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem("pendingMonitorUrl");
}

/**
 * Stores a pending monitor URL in localStorage
 */
export function setPendingMonitorUrl(url: string): void {
  if (typeof window === "undefined") return;
  localStorage.setItem("pendingMonitorUrl", url);
}

/**
 * Clears the pending monitor URL from localStorage
 */
export function clearPendingMonitorUrl(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem("pendingMonitorUrl");
}

/**
 * Determines where to redirect after successful login
 */
export function getPostLoginRedirectUrl(defaultUrl: string = "/dashboard/monitors"): string {
  const pendingUrl = getPendingMonitorUrl();
  return pendingUrl ? "/dashboard/monitors" : defaultUrl;
}
